import { render, staticRenderFns } from "./promo-sales-items.vue?vue&type=template&id=69b30a6a"
import script from "./promo-sales-items.vue?vue&type=script&lang=js"
export * from "./promo-sales-items.vue?vue&type=script&lang=js"
import style0 from "./promo-sales-items.vue?vue&type=style&index=0&id=69b30a6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports